export default __webpack_public_path__ + "static/media/titulo_charlas.608d034b.jpg";